var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"emd-container emd-card eu-width_100 _highlight_header _header_spaced",style:({ backgroundColor: _vm.backgroundColor })},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }